import { Pageable } from 'src/app/shared/models/pageable';
import { Card } from './card-implementations/card';

export class CardPage {
    itemCards: Card[] = [];
    numberOfPages: number;
    numberOfItems: number;
    pageable: Pageable;
}
